module.exports = __webpack_public_path__ + "Flama-Extrabold.ttf?f636240be5287f16c59044c4e5227d1e";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Extrabold.ttf
// module id = 919
// module chunks = 0